<template src="./template.html" />

<script>
/* eslint-disable */
import _ from 'lodash';
import InputText from "@/components/elements/inputs/text.vue";
import RadioButton from "@/components/elements/inputs/radio.vue";
import CurrencySelect from '@/components/elements/inputs/currencySelect.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import Calendar from '@/components/elements/inputs/calendar.vue';

export default {
  name: 'ServiceGroup',
  components: {
    InputText,
    RadioButton,
    CurrencySelect,
    InputSelect,
    Calendar,
  },
  props: {
    shippingDate: {
      type: [String, Date],
      default: '',
    },
    service: {
      type: Object,
    },
    selectedServices: {
      type: Array,
    },
    servicesAllowed: {
      type: Array,
      default: () => {
        return [];
      },
    },
    additionalFieldData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      opened: false,
      serviceId: '',
      additionalData: {},
      extraFieldVisible: false,
      inputValue: '',
      timeValue: '',
      shippingDateComponent: this.getAdditionalServiceShippingDate(),
      unitValue: {
        value: '',
        unit: 'dkk',
      },
      timeStamps: [
        '06:00', '06:15', '06:30', '06:45',
        '07:00', '07:15', '07:30', '07:45',
        '08:00', '08:15', '08:30', '08:45',
        '09:00', '09:15', '09:30', '09:45',
        '10:00', '10:15', '10:30', '10:45',
        '11:00', '11:15', '11:30', '11:45',
        '12:00', '12:15', '12:30', '12:45',
        '13:00', '13:15', '13:30', '13:45',
        '14:00', '14:15', '14:30', '14:45',
        '15:00', '15:15', '15:30', '15:45',
        '16:00', '16:15', '16:30', '16:45',
        '17:00', '17:15', '17:30', '17:45',
        '18:00', '18:15', '18:30', '18:45',
        '19:00', '19:15', '19:30', '19:45',
        '20:00',
      ],
    };
  },
  computed: {
    timeOptions() {
      // return this.timeStamps.map((stamp) => {
      //   return {text: stamp, value: stamp}
      // })
      return this.mapTimesAfter();
    },
  },
  mounted() {
    Object.keys(this.service.services).forEach(key => {
      if( this.selectedServices.indexOf(this.service.services[key].id) > -1 ){
        this.opened = true;
        this.serviceId = this.service.services[key].id;
      }
    })
    if(!_.isEmpty(this.additionalFieldData)) {
      this.selectedServices.forEach((val) => {
        let data = this.additionalFieldData[val];
        this.additionalData[data.fee_wrapper_id] = data;
        if (data.service_category == 24) { //Without POD category
          this.inputValue = data.details;
        } else if (data.service_category == 8) { //Preffered day category
          this.shippingDateComponent = new Date(data.date);
        } else {
          this.inputValue = data.value;
          this.unitValue = {
            value: data.value,
            unit: data.currency,
          };
        }
      })
    }
  },
  methods: {
    mapTimesAfter() {
      let startHour;
      const startTime = '06:00'
      let currentDate = this.getFormatedDate(new Date());
      let userDate = this.getFormatedDate(this.shippingDateComponent);
      //If current time is after start time use current time for range
      if (currentDate.date == userDate.date && currentDate.time > startTime) {
        startHour = currentDate.time;
      } else {
        startHour = startTime;
      }
      return this.timeStamps.filter((hour) => {
        if(hour > startHour) return hour;
      }).map((time) => {
        return {text: time, value: time};
      })
    },
    getFormatedDate(dateTime) {
      let d = new Date(dateTime);
      let day = d.getDate();
      let month = d.getMonth() + 1;
      let hours = String(d.getHours());
      let minutes = String(d.getMinutes());

      if (day < 10) day = `0${day}`
      if (month < 10) month = `0${month}`
      if (hours.length == 1) hours = `0${hours}`
      if (minutes.length == 1) minutes = `0${minutes}`

      return {
        date: `${d.getFullYear()}-${month}-${day}`,
        time: `${hours}:${minutes}`,
      };
    },
    removeServiceEmit() {
      this.additionalData = {};
      this.inputValue = '';
      this.unitValue = {
        value: '',
        unit: 'dkk',
      };
      this.timeValue = '';
      this.$emit('serviceRemove', {
        serviceID: this.serviceId,
        additionalFieldData: {},
      });
    },
    removeServiceSubEmit(serviceID) {
      this.additionalData = {};
      this.inputValue = '';
      this.unitValue = {
        value: '',
        unit: 'dkk',
      };
      this.timeValue = '';
      this.$emit('serviceRemove', {
        serviceID: serviceID,
        additionalFieldData: {},
      });
    },
    setExtraFieldData(val, dataObj) {
      if(dataObj.type == 'timeSelect'){
        if(dataObj.dataType == 'time') this.timeValue = val;
        if(dataObj.dataType == 'date') this.shippingDateComponent = val;
        this.additionalData[dataObj.id] = {
          name: dataObj.name,
          [dataObj.name]: this.timeValue,
          date: this.shippingDateComponent,
          service_category: this.service.id,
        };

        if( this.timeValue == '' || this.shippingDateComponent == '') return
        if( this.timeValue == undefined || this.shippingDateComponent == undefined) return
        if( this.timeValue == null || this.shippingDateComponent == null) return

        this.serviceId = dataObj.id;
        this.$emit('extraFieldAdd', {
          additionalData: this.additionalData,
          serviceId: this.serviceId,
        });
      }

      if(dataObj.type == 'dateSelect'){
        if(dataObj.dataType == 'date') this.shippingDateComponent = val;
        this.additionalData[dataObj.id] = {
          name: dataObj.name,
          [dataObj.name]: this.shippingDateComponent,
          service_category: this.service.id,
        };

        if( this.shippingDateComponent == '') return
        if( this.shippingDateComponent == undefined) return
        if( this.shippingDateComponent == null) return

        this.serviceId = dataObj.id;
        this.$emit('extraFieldAdd', {
          additionalData: this.additionalData,
          serviceId: this.serviceId,
        });
      }

      if(dataObj.type == 'currencySelect'){
        this.unitValue.value = val.value;
        this.unitValue.unit = val.unit;
        this.additionalData[dataObj.id] = {
          name: dataObj.name,
          value: val.value,
          [dataObj.name]: val.unit,
          service_category: this.service.id,
        };
        if( this.unitValue.value == '' || this.unitValue.unit == '') return
        if( this.unitValue.value == undefined || this.unitValue.unit == undefined) return
        if( this.unitValue.value == null || this.unitValue.unit == null) return

        this.serviceId = dataObj.id;
        this.$emit('extraFieldAdd', {
          additionalData: this.additionalData,
          serviceId: this.serviceId,
        });
      }

      if(dataObj.type == 'text'){
        this.inputValue = val;
        this.additionalData[dataObj.id] = {
          name: dataObj.name,
          [dataObj.name]: this.inputValue,
          service_category: this.service.id,
        };

        //If category is without proof of delivery pass through
        if(this.service.id != 24 && (this.inputValue == '' || this.inputValue == undefined || this.inputValue == null)) return

        this.serviceId = dataObj.id;
        this.$emit('extraFieldAdd', {
          additionalData: this.additionalData,
          serviceId: this.serviceId,
        });
      }
    },
    resetService() {
      this.opened = false;
      this.removeServiceEmit();
      this.serviceId = '';
      this.allowedProducts = [];
    },
    getAdditionalServiceShippingDate() {
      return (this.shippingDateComponent && this.shippingDateComponent > this.shippingDate) ? this.shippingDateComponent : this.shippingDate;
    },
    chosenService(id, item) {
      // IF additional data
      if(item.extra_field_data.length > 0){
        let previousActiveServiceId = this.serviceId;
        this.serviceId = id;
        if(item.extra_field_data[0].type == 'timeSelect') {
          if( this.timeValue == '' || this.shippingDateComponent == '') return
          if( this.timeValue == undefined || this.shippingDateComponent == undefined) return
          if( this.timeValue == null || this.shippingDateComponent == null) return
        }
        if(item.extra_field_data[0].type == 'dateSelect') {
          if( this.shippingDateComponent == '' || this.shippingDateComponent == undefined || this.shippingDateComponent == null) return
        }
        if(item.extra_field_data[0].type == 'currencySelect') {
          if( this.unitValue.value == '' || this.unitValue.unit == '') return
          if( this.unitValue.value == undefined || this.unitValue.unit == undefined) return
          if( this.unitValue.value == null || this.unitValue.unit == null) return
        }
        if(item.extra_field_data[0].type == 'text') {
          //If category is 'Without proof of delivery' trigger event to set service and call 'rate' request
          if(item.wrapper_category == 24) {
            this.setExtraFieldData('', {
              type: 'text',
              name: item.extra_field_data[0].name,
              id: item.id
            })
            return
          } else {
            if( this.inputValue == '' || this.inputValue == undefined || this.inputValue == null) return
          }
        }

        if(this.serviceId === ''){
          this.$emit('serviceAdd', {
            serviceID: id,
            additionalFieldData: this.additionalData,
          });
        } else {
          this.removeServiceSubEmit(previousActiveServiceId);
        }
      } else {
        // IF NOT additional data
        if(this.serviceId === ''){
          this.$emit('serviceAdd', {
            serviceID: id,
            additionalFieldData: this.additionalData,
          });
        } else {
          this.removeServiceEmit();
          this.$emit('serviceAdd', {
            serviceID: id,
            additionalFieldData: this.additionalData,
          });
        }

        this.serviceId = id;
      }
    },
  },
  watch: {
    'shippingDate': function() {
      this.shippingDateComponent = this.getAdditionalServiceShippingDate();
    },
  }
}
</script>
